import { api } from "./api";

export const SessaoService = {

    async findAll() {
        const response = await api.get("/sessoes");
        return response.data;
    },

    async findByZona(
        zonaId: number
    ) {

        const response =
            await api.get(
                `/sessoes/zona/${zonaId}`
            );

        return response.data;
    },

    async create(data: any) {
        const response = await api.post("/sessoes", data);
        return response.data;
    },

    async update(id: number, data: any) {
        const response = await api.put(`/sessoes/${id}`, data);
        return response.data;
    },

    async delete(id: number) {
        const response = await api.delete(`/sessoes/${id}`);
        return response.data;
    }
};

